module.exports = __webpack_public_path__ + "static/media/icon_configuracion.308f1cde.svg";